import { motion } from "framer-motion"; // Import Framer Motion
import TitleBar from "../../TitleBar/TitleBarWithoutDivider";
import TitleWithContent from "../../titlewithcontent(without divider)/TitleWithContentWithoutDivider";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import CustomLists from "@/components/elements/CustomLists/CustomLists";

const CookiePolicy = () => {
  return (
    <div className="bg-custom-background pb-0 px-0 sm:px-1 2xl:px-40 xl:px-40 md:px-[3rem] ">
      <div className="pt-10">
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 0.5 }}
        >
          <TitleBar title="Cookie Policy" />
        </motion.div>
      </div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.7, opacity: { duration: 0.5 } } },
        }}
      >
        <TitleWithContent title="Introduction">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="This Cookie Policy explains how Sheel Waterproofing Nepal Pvt. Ltd. uses cookies and similar technologies on our website to enhance your experience." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="What Are Cookies?">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="Cookies are small data files stored on your device that help websites remember your preferences and improve user experience." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Types of Cookies We Use">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <CustomLists
            layout="stacked"
            listStyle="disc"
              items={[
                [
                  "Essential Cookies – Necessary for the website to function properly.",
                  "Performance Cookies – Help us understand how visitors interact with our website.",
                  "Functional Cookies – Remember your preferences and choices.",
                ],
              ]}
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Managing Cookies">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="You can manage or disable cookies through your browser settings. Please note that disabling cookies may affect the functionality of our website." />
          </motion.div>
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default CookiePolicy;
